<template>
  <div>
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :matterId="egress_profile_matter_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
      :showPlannification="true"
      :showMatterDescriptionView="true"
      :showLearningExperiencesView="true"
      :showPiaView="true"
      :showPdaView="true"
      :showPaView="true"
    ></NavigationBreadcrumb>
    <div class="text-center mt-3">
      <h4>
        {{
          $t(
            "matterProgram.learningEvaluationView.evaluationsTitle"
          ).toUpperCase()
        }}
        <span v-if="matter">
          <span
            v-b-tooltip.v-secondary.noninteractive="
              `${$getVisibleNames('manual.matter_code', false, 'Código')}`
            "
          >{{ matter.code }}</span>
          <template
            v-if="
              institution &&
              institution.use_epm_code &&
              egressProfilesMatter &&
              egressProfilesMatter.code &&
              egressProfilesMatter.code !== matter.code
            "
          >
            -
            <span
              v-b-tooltip.v-secondary.noninteractive="
                `${$getVisibleNames('manual.ep_matter_code', false, 'Código')}`
              "
            >{{ egressProfilesMatter.code }}</span>
          </template>
          - {{ matter.name }}
        </span>
      </h4>
    </div>
    <div class="d-flex">
      <GenericButtonDownload
        v-if="egressProfilesMatter"
        :tooltip_text="
          $t(
            'matterProgram.learningEvaluationView.evaluationXLSX'
          ).toUpperCase()
        "
        :click_button="
          () => LearningSuitcasePageTwo(egressProfilesMatter.matter)
        "
        :class="`ml-auto mb-2 mr-3`"
        :icon_excel="true"
      ></GenericButtonDownload>
      <!-- <b-button
        v-if="egressProfilesMatter"
        class="learning-suitcase-btn"
        size="sm"
        @click="LearningSuitcasePageTwo(egressProfilesMatter.matter)"
        ><b-icon-download class="mr-1 icon-download"></b-icon-download
        >EVALUACIÓN XLS</b-button
      > -->
    </div>
    <div class="learning-experiences-container">
      <TableSkeleton
        v-if="loading"
        :columns="
          institution && institution.internal_use_id == 'duoc.cl' ? 16 : 13
        "
        :rows="12"
        :table_props="{
          bordered: true,
          'no-border-collapse': true,
          small: true,
          fixed: true,
          responsive: true,
        }"
      />
      <b-table-simple
        v-else
        bordered
        no-border-collapse
        small
        fixed
        responsive
        sticky-header="1000px"
        class="txt-custom"
      >
        <b-thead>
          <b-tr>
            <b-th
              class="text-center primary-header"
              :colspan="
                institution && institution.internal_use_id == 'duoc.cl'
                  ? 16
                  : 13
              "
              >{{
                $t("matterProgram.learningEvaluationView.evaluations")
              }}</b-th
            >
          </b-tr>
          <b-tr>
            <b-th class="text-center align-middle secondary-header">
              {{ $t("matterProgram.learningEvaluationView.evaluationType") }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{ $t("matterProgram.learningEvaluationView.learningOutcome") }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{
                $t("matterProgram.learningEvaluationView.achievementIndicators")
              }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{
                $t("matterProgram.learningEvaluationView.evaluativeSituation")
              }}
            </b-th>
            <b-th
              v-if="institution && institution.internal_use_id == 'duoc.cl'"
              class="text-center align-middle secondary-header"
            >
              {{
                $t("matterProgram.learningEvaluationView.authenticEvaluation")
              }}
            </b-th>
            <b-th
              class="text-center align-middle secondary-header"
              v-b-tooltip.v-secondary.noninteractive="
                $t(
                  'matterProgram.learningEvaluationView.evaluationDescriptionTooltip'
                )
              "
            >
              {{
                $t("matterProgram.learningEvaluationView.evaluationDescription")
              }}
            </b-th>
            <b-th
              v-if="institution && institution.internal_use_id == 'duoc.cl'"
              class="text-center align-middle secondary-header"
            >
              {{
                $t(
                  "matterProgram.learningEvaluationView.connectionWithEnvironment"
                )
              }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{ $t("matterProgram.learningEvaluationView.evaluativeAgent") }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{
                $t("matterProgram.learningEvaluationView.evaluationWeighting")
              }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{
                $t(
                  "matterProgram.learningEvaluationView.weightingByEvaluativeSituation"
                )
              }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{
                $t("matterProgram.learningEvaluationView.directedTeachingHours")
              }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{
                $t("matterProgram.learningEvaluationView.autonomousWorkHours")
              }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{ $t("matterProgram.learningEvaluationView.workType") }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{ $t("matterProgram.learningEvaluationView.environment") }}
            </b-th>
            <b-th class="text-center align-middle secondary-header">
              {{ $t("matterProgram.learningEvaluationView.examiner") }}
            </b-th>
            <b-th
              v-if="institution && institution.internal_use_id == 'duoc.cl'"
              class="text-center align-middle secondary-header"
            >
              {{ $t("matterProgram.learningEvaluationView.avaLiberationWeek") }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-if="learning_evaluation.length > 0">
            <template v-for="matter_evaluation in learning_evaluation">
              <b-tr
                v-for="(evaluation_test, index) in matter_evaluation.tests"
                :key="
                  index + 'index_test' + matter_evaluation.id + 'id_evaluation'
                "
              >
                <!-- Tipo de evaluación -->
                <b-td
                  v-if="index == 0"
                  class="text-left"
                  :rowspan="matter_evaluation.tests.length"
                >
                  {{ matter_evaluation.evaluation_type }}
                </b-td>
                <!-- Resultado de aprendizaje -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                >
                  {{ matter_evaluation.learning_results }}
                </b-td>
                <!-- Indicadores de Logro -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                >
                  {{ matter_evaluation.evaluation_criterias_micro }}
                </b-td>
                <!-- Situación evaluativa -->
                <b-td class="text-left">
                  {{ evaluation_test.evaluation_situation }}
                </b-td>
                <!-- Evaluación Auténtica -->
                <b-td
                  v-if="institution && institution.internal_use_id == 'duoc.cl'"
                  class="text-left"
                  :class="{
                    'authentic-cell':
                      evaluation_test.authentic_evaluation == '-',
                  }"
                >
                  {{ evaluation_test.authentic_evaluation }}
                </b-td>
                <!-- Descripción evaluación -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                >
                  <RenderVHtml
                    class="description-evaluation"
                    :content="matter_evaluation.description"
                  ></RenderVHtml>
                </b-td>
                <!-- Vinculación con el Medio -->
                <b-td
                  v-if="
                    index == 0 &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl'
                  "
                  :rowspan="matter_evaluation.tests.length"
                >
                  <RenderVHtml
                    class="rich-text-content description-evaluation"
                    :class="{
                      'text-center':
                        matter_evaluation.connection_with_the_environment_description ==
                        '-',
                    }"
                    :content="
                      matter_evaluation.connection_with_the_environment_description
                    "
                  ></RenderVHtml>
                </b-td>
                <!-- Agente evaluativo -->
                <b-td class="text-left">
                  {{ evaluation_test.evaluative_agent }}
                </b-td>
                <!-- Ponderación evaluación -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                >
                  {{ matter_evaluation.weighing }}%</b-td
                >
                <!-- Ponderación por Situacion Evaluativa -->
                <b-td> {{ evaluation_test.weighing }}% </b-td>
                <!-- Horas de Docencia Dirigida (pedagógicas) -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                  class="text-left"
                >
                  <div
                    v-for="(
                      pedagogical_hour, index
                    ) in matter_evaluation.pedagogical_hours.filter(
                      (x) => x.hours > 0
                    )"
                    :key="`pedagogical_hour-${index}`"
                  >
                    <p>
                      {{ pedagogical_hour.hours }}
                      {{ $t("matterProgram.learningEvaluationView.hrs") }}
                      {{
                        pedagogical_hour.study_environment != null
                          ? pedagogical_hour.study_environment
                          : $t("reusable.common.withoutEntity", {
                              entity: $getVisibleNames(
                                "mesh.studyenvironment",
                                false,
                                "Ambiente de Aprendizaje"
                              ),
                            })
                      }}
                    </p>
                  </div>
                </b-td>
                <!-- Horas de Trabajo Autónomo Preparación y/o Ejecución
              (cronológicas)  -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                  class="text-left"
                >
                  <div
                    v-for="(
                      chronological_hour, index
                    ) in matter_evaluation.chronological_hours.filter(
                      (x) => x.hours > 0
                    )"
                    :key="`chronological_hour-${index}`"
                  >
                    <p>
                      {{ chronological_hour.hours }}
                      {{ $t("matterProgram.learningEvaluationView.hrs") }}
                      {{
                        chronological_hour.study_environment != null
                          ? chronological_hour.study_environment
                          : $t("reusable.common.withoutEntity", {
                              entity: $getVisibleNames(
                                "mesh.studyenvironment",
                                false,
                                "Ambiente de Aprendizaje"
                              ),
                            })
                      }}
                    </p>
                  </div>
                </b-td>
                <!-- Tipo de trabajo -->
                <b-td>
                  {{ evaluation_test.work_type }}
                </b-td>
                <!-- Ambiente -->
                <b-td
                  v-if="index == 0"
                  :rowspan="matter_evaluation.tests.length"
                >
                  {{ matter_evaluation.study_environments }}
                </b-td>
                <!-- Examinador/a -->
                <b-td>
                  {{ evaluation_test.examiner }}
                </b-td>
                <!-- Semana Liberación AVA -->
                <b-td
                  v-if="
                    index == 0 &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl'
                  "
                  :rowspan="matter_evaluation.tests.length"
                >
                  <span v-if="matter_evaluation.liberation_week_at_ava">
                    {{ matter_evaluation.liberation_week_at_ava }}
                  </span>
                  <span v-else> - </span>
                </b-td>
              </b-tr>

              <!-- TEMPLATE cuando NO existen test -->
              <template v-if="matter_evaluation.tests.length == 0">
                <b-tr :key="matter_evaluation.id + 'id_evaluation'">
                  <!-- Tipo de evaluación -->
                  <b-td class="text-left">
                    {{ matter_evaluation.evaluation_type }}
                  </b-td>
                  <!-- Resultado de aprendizaje -->
                  <b-td>
                    {{ matter_evaluation.learning_results }}
                  </b-td>
                  <!-- Indicadores de Logro -->
                  <b-td>
                    {{ matter_evaluation.evaluation_criterias_micro }}
                  </b-td>
                  <!-- Situación evaluativa -->
                  <b-td class="text-left"> </b-td>
                  <!-- Evaluación Auténtica -->
                  <b-td
                    v-if="
                      institution && institution.internal_use_id == 'duoc.cl'
                    "
                    class="text-left"
                  >
                  </b-td>
                  <!-- Descripción evaluación -->
                  <b-td>
                    <RenderVHtml
                      class="description-evaluation"
                      :content="matter_evaluation.description"
                    ></RenderVHtml>
                  </b-td>
                  <!-- Vinculación con el Medio -->
                  <b-td
                    v-if="
                      institution && institution.internal_use_id == 'duoc.cl'
                    "
                  >
                    <RenderVHtml
                      class="description-evaluation"
                      :class="{
                        'text-center':
                          matter_evaluation.connection_with_the_environment_description ==
                          '-',
                      }"
                      :content="
                        matter_evaluation.connection_with_the_environment_description
                      "
                    ></RenderVHtml>
                  </b-td>
                  <!-- Agente evaluativo -->
                  <b-td class="text-left"> </b-td>
                  <!-- Ponderación evaluación -->
                  <b-td> {{ matter_evaluation.weighing }}%</b-td>
                  <!-- Ponderación por Situacion Evaluativa -->
                  <b-td></b-td>
                  <!-- Horas de Docencia Dirigida (pedagógicas) -->
                  <b-td class="text-left">
                    <div
                      v-for="(
                        pedagogical_hour, index
                      ) in matter_evaluation.pedagogical_hours.filter(
                        (x) => x.hours > 0
                      )"
                      :key="`pedagogical_hour-${index}`"
                    >
                      <p>
                        {{ pedagogical_hour.hours }}
                        {{ $t("matterProgram.learningEvaluationView.hrs") }}
                        {{
                          pedagogical_hour.study_environment != null
                            ? pedagogical_hour.study_environment
                            : $t("reusable.common.withoutEntity", {
                                entity: $getVisibleNames(
                                  "mesh.studyenvironment",
                                  false,
                                  "Ambiente de Aprendizaje"
                                ),
                              })
                        }}
                      </p>
                    </div>
                  </b-td>
                  <!-- Horas de Trabajo Autónomo Preparación y/o Ejecución
              (cronológicas)  -->
                  <b-td class="text-left">
                    <div
                      v-for="(
                        chronological_hour, index
                      ) in matter_evaluation.chronological_hours.filter(
                        (x) => x.hours > 0
                      )"
                      :key="`chronological_hour-${index}`"
                    >
                      <p>
                        {{ chronological_hour.hours }}
                        {{ $t("matterProgram.learningEvaluationView.hrs") }}
                        {{
                          chronological_hour.study_environment != null
                            ? chronological_hour.study_environment
                            : $t("reusable.common.withoutEntity", {
                                entity: $getVisibleNames(
                                  "mesh.studyenvironment",
                                  false,
                                  "Ambiente de Aprendizaje"
                                ),
                              })
                        }}
                      </p>
                    </div>
                  </b-td>
                  <!-- Tipo de trabajo -->
                  <b-td> </b-td>
                  <!-- Ambiente -->
                  <b-td>
                    {{ matter_evaluation.study_environments }}
                  </b-td>
                  <!-- Examinador/a -->
                  <b-td> </b-td>
                  <!-- Semana Liberación AVA -->
                  <b-td
                    v-if="
                      institution && institution.internal_use_id == 'duoc.cl'
                    "
                  >
                    <span v-if="matter_evaluation.liberation_week_at_ava">
                      {{ matter_evaluation.liberation_week_at_ava }}
                    </span>
                    <span v-else> - </span>
                  </b-td>
                </b-tr>
              </template>
            </template>
          </template>
          <!-- Template cuando no hay evaluaciones -->
          <template v-else-if="learning_evaluation.length == 0">
            <b-tr>
              <b-td colspan="13">
                <strong> {{ $t("reusable.common.noDataToShow") }} </strong>
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { showLoadingAlert, downloadFileFromResponse } from "@/utils/utils";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";
export default {
  name: "LearningEvaluationView",
  mixins: [matterLanguageMixin],
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    TableSkeleton: () => import("@/components/reusable/TableSkeleton"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      egress_profile_matter_id: Number(
        this.$route.params.egress_profile_matter_id
      ),
      disabled_button_excel: false,
      learning_evaluation: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    isStudent() {
      return this.user && this.user.group_names.includes("ESTUDIANTES");
    },
    isProfessor() {
      return this.user && this.user.group_names.includes("PROFESORES");
    },
    matter() {
      if (!this.egressProfilesMatter) return null;
      return this.matters.find((x) => x.id == this.egressProfilesMatter.matter);
    },
    egressProfilesMatter() {
      if (!this.egress_profile_matter_id) return null;
      return this.egress_profiles_matters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    breadcrumb() {
      // Recuperar contexto del breadcrumb desde localStorage
      const context = localStorage.getItem("breadcrumb");
      return context ? JSON.parse(context) : {};
    },
    breadcrumbEgressProfileId() {
      return this.breadcrumb.egress_profile_id || null;
    },
    breadcrumbEgressProfileMatterId() {
      return this.breadcrumb.egress_profile_matter_id || null;
    },
    breadcrumb_items() {
      let breadcrumb = [];
      let egressProfileId =
        this.breadcrumbEgressProfileId ||
        this.egressProfilesMatter?.egress_profile;
      let egressProfileMatterId =
        this.breadcrumbEgressProfileMatterId || this.egress_profile_matter_id;

      if (egressProfileId && egressProfileMatterId) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          {
            text: this.$getVisibleNames("mesh.career", true, "Programas"),
            to: "/careers",
          },
          {
            text: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
            to: `/matrix2/form/${egressProfileId}`,
            dropdownOptions: [
              "showEgressProfile",
              "showMatrix1",
              "showMatrix2",
              "showMatrix3",
              "showMatrix4",
              "showStudyPlan",
              "showCurricularMesh",
            ],
          },
          {
            text: this.$getVisibleNames(
              "manual.matter_program",
              false,
              "Programa de la Asignatura"
            ),
            to: `/matter/form/${egressProfileMatterId}`,
            dropdownOptions: ["showPlannification"],
          },
          {
            text: this.$t("reusable.breadcrumb.evaluations"),
            ...(!this.isStudent &&
              !this.isProfessor && {
                dropdownOptions: [
                  "showMatterDescriptionView",
                  "showLearningExperiencesView",
                  "showPiaView",
                  "showPdaView",
                  "showPaView",
                ],
              }),
          },
        ];
      }
      return breadcrumb;
    },
  },
  methods: {
    LearningSuitcasePageTwo(matter_id) {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      if (matter_id)
        this.$restful
          .Post(
            `/teaching/learning_suitcase_page_two_excel/`,
            {
              egress_profile_matter: this.egress_profile_matter_id,
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            this.$swal.close();
            if (response) {
              downloadFileFromResponse(
                response,
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                () => {
                  this.disabled_button_excel = false;
                },
                () => {
                  this.disabled_button_excel = false;
                  this.$swal.fire(
                    this.$t("reusable.common.error"),
                    this.$t("reusable.common.downloadError"),
                    "error"
                  );
                }
              );
            } else {
              this.disabled_button_excel = false;
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.generateError"),
                "error"
              );
            }
          })
          .catch(() => {
            this.disabled_button_excel = false;
            this.$swal.close();
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.problemGenerating"),
              "error"
            );
          });
    },
  },
  watch: {
    egressProfilesMatter: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (
          this.user &&
          this.user.student_card &&
          this.user.group_names.includes("ESTUDIANTES") &&
          this.user.student_card.egress_profile != val.egress_profile
        ) {
          this.$router.push({ name: "Page403" });
        }
        if (this.user && this.user.group_names.includes("PROFESORES")) {
          this.$restful
            .Get(`/mesh/fully_visible_professor_egress_profiles/`)
            .then((response) => {
              if (!response.includes(val.egress_profile)) {
                this.$router.push({ name: "Page403" });
              }
            });
        }
      },
    },
  },
  mounted() {},
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
  },
  created() {
    this.$store
      .dispatch(
        names.FETCH_EGRESS_PROFILE_MATTER,
        this.egress_profile_matter_id
      )
      .then((egress_profile_matter) => {
        if (egress_profile_matter && egress_profile_matter.matter) {
          this.$restful
            .Get(
              `/teaching/learning_suitcase_page_two_web/?egress_profile_matter=${this.egress_profile_matter_id}`
            )
            .then((learning_evaluation) => {
              this.learning_evaluation = learning_evaluation;
              this.loading = false;
            });
          this.$store
            .dispatch(names.FETCH_MATTER, egress_profile_matter.matter)
            .then((matter) => {
              this.$store.commit(
                names.MUTATE_TITLE_OF_THE_PRINT,
                this.$t(
                  "matterProgram.learningEvaluationView.evaluationsPrintTitle",
                  {
                    code: egress_profile_matter.effective_code,
                    name: matter.name,
                  }
                )
              );
              this.applyMatterLanguageById(matter.default_language);
            });
        }
      });
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.authentic-cell {
  text-align: center !important;
}
.description-evaluation {
  max-height: 190px;
  overflow-y: auto;
  overflow-x: hidden;
}
.learning-suitcase-btn {
  margin-left: auto;
  margin-right: 0;
}
.txt-custom {
  font-size: 9pt;
}
.primary-header {
  background: black !important;
  color: white !important;
  font-weight: bold !important;
  font-size: 26px;
}
.secondary-header {
  background: #d0cece !important;
}
@media print {
  .badge {
    border: none !important;
  }
  .learning-experiences-container {
    zoom: 52%;
    display: table;
    table-layout: inherit;
  }
}
</style>